import React from 'react';

import { Grid, Typography } from '@mui/material';

import {
  AttacksByProvince,
  KingdomAttacksByProvince,
} from '../../@types/KingdomNews';

interface KingdomUniquesProps {
  kingdom: KingdomAttacksByProvince;
}

const KingdomUniques: React.FC<KingdomUniquesProps> = ({ kingdom }) => {
  return (
    <Grid
      key={kingdom.kingdomReference}
      item
      lg={3}
      md={4}
      sm={6}
      xs={12}
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <Typography
        variant='body1'
        gutterBottom
        component='div'
        sx={{ fontWeight: 'bold' }}
      >
        Uniques for {kingdom.kingdomReference}
      </Typography>
      {kingdom.attacksByProvinces
        .filter((p) => p.uniques > 0)
        .sort((a, b) => b.uniques - a.uniques)
        .map((p: AttacksByProvince) => (
          <Typography key={p.provinceName} variant='body2' component='div'>
            {p.provinceName} {p.uniques}
          </Typography>
        ))}
    </Grid>
  );
};

export default KingdomUniques;
